<template>
  <div class="flex-grow-1"></div>
  <footer
    class="footer-area text-center text-md-start bg-white ps-15 pe-15 pt-20 pb-20 ps-md-40 pe-md-40 pt-md-25 pb-md-25">
    <!-- FOOTER LINKS -->
    <div class="row align-items-center">
      <div class="col-auto">
        <FooterLinks v-if="env === 'sifi_fk' || env === 'fungalk'" />
      </div>
    </div>
    <div class="row align-items-center">
      <!-- <div class="col-md-6 col-lg-6"> -->
      <div class="col-auto">
        <p class="text-body-secondary fw-medium mb-0">
          © {{ year }} <span class="fw-bold text-primary">{{ name }}</span> - {{ disclaimer }}{{ disclaimer != '' ? ' - ' :
          '' }} <span class="text-body-emphasis">{{ version }}</span>
        </p>
      </div>

      <!-- <div class="col-md-6 col-lg-6 text-md-end">
        <ul class="footer-menu ps-0 mb-0 list-unstyled fw-medium">
          <li class="d-inline-block">
            <router-link
              to="/privacy-policy"
              class="text-decoration-none text-body-secondary transition"
            >
              Privacy Policy
            </router-link>
          </li>
          <li class="d-inline-block">
            <router-link
              to="/terms-conditions"
              class="text-decoration-none text-body-secondary transition"
            >
              Terms & Conditions
            </router-link>
          </li>
        </ul>
      </div> -->
    </div>
  </footer>
</template>

<script lang="ts">
import { Environment } from '@/utils/const/config';
import { CLIENT } from '@/utils/const/env';
import dayjs from 'dayjs';
import { defineComponent } from 'vue';
import FooterLinks from './FooterLinks.vue';

const _version = process.env.VUE_APP_VERSION;
const _app_name = process.env.VUE_APP_NAME;
export default defineComponent({
  name: "MainFooter",
  components: {
    FooterLinks
  },
  computed: {
    year() { return dayjs().year() },
    version() { return _version },
    name() { return _app_name },
    disclaimer() { return this.$t(`footer_disclaimer.${CLIENT}`) },
    // config() { return config },
    env(): Environment { return CLIENT },
  }
});
</script>